import { ConnectButton } from '@rainbow-me/rainbowkit';
import { hasWalletConnect } from '../web3/config';

const BASE =
  'rounded-sm border px-3 py-1.5 font-mono text-[11px] uppercase tracking-wider transition-colors';

export default function WalletButton() {
  return (
    <ConnectButton.Custom>
      {({ account, chain, mounted, openAccountModal, openChainModal, openConnectModal }) => {
        const ready = mounted;
        const connected = ready && account && chain;

        return (
          <div
            {...(ready
              ? {}
              : { 'aria-hidden': true as const, style: { opacity: 0, pointerEvents: 'none' as const } })}
          >
            {!connected ? (
              <button
                type="button"
                onClick={openConnectModal}
                title={
                  hasWalletConnect
                    ? 'Connect a wallet'
                    : 'WalletConnect is off (no project id) — injected wallets only'
                }
                className={`${BASE} border-white/15 text-gray-200 hover:bg-white/5`}
              >
                Connect Wallet
              </button>
            ) : chain.unsupported ? (
              <button
                type="button"
                onClick={openChainModal}
                className={`${BASE} border-amber-500/40 text-amber-300 hover:bg-amber-500/10`}
              >
                Wrong network
              </button>
            ) : (
              <button
                type="button"
                onClick={openAccountModal}
                className={`${BASE} border-white/15 text-gray-200 hover:bg-white/5`}
              >
                <span
                  className="mr-1.5 inline-block size-1.5 rounded-full bg-green-500 align-middle"
                  aria-hidden="true"
                />
                {account.displayName}
              </button>
            )}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
}
